import {datadogLogs} from '@datadog/browser-logs';

import shouldForwardDatadogLog from 'services/logger/shouldForwardDatadogLog';

datadogLogs.init({
  clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN || '',
  site: process.env.REACT_APP_DD_SITE || '',
  env: process.env.REACT_APP_ENV,
  service: process.env.REACT_APP_DD_SERVICE_NAME,
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  version: process.env.REACT_APP_VERSION,
  beforeSend: shouldForwardDatadogLog
});
export default datadogLogs;
